(function(){
  function closeAll(except){document.querySelectorAll('.ed-mega__trigger[aria-expanded="true"]').forEach(function(b){if(b!==except){b.setAttribute('aria-expanded','false');document.getElementById(b.getAttribute('aria-controls')).hidden=true;}});}
  function setOpen(b,open){b.setAttribute('aria-expanded',open?'true':'false');document.getElementById(b.getAttribute('aria-controls')).hidden=!open;}
  document.querySelectorAll('.ed-mega').forEach(function(li){
    var b=li.querySelector('.ed-mega__trigger'),t;
    b.addEventListener('click',function(e){e.preventDefault();var o=b.getAttribute('aria-expanded')!=='true';closeAll(b);setOpen(b,o);});
    if(window.matchMedia('(hover: hover)').matches){
      li.addEventListener('mouseenter',function(){clearTimeout(t);closeAll(b);setOpen(b,true);});
      li.addEventListener('mouseleave',function(){t=setTimeout(function(){setOpen(b,false);},150);});
    }
    li.addEventListener('focusout',function(e){if(!li.contains(e.relatedTarget))setOpen(b,false);});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){var o=document.querySelector('.ed-mega__trigger[aria-expanded="true"]');if(o){setOpen(o,false);o.focus();}}});
  document.addEventListener('click',function(e){if(!e.target.closest('.ed-mega'))closeAll();});
  // Capture phase so the theme drawer's own button handler (which closes the drawer) never sees these clicks.
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.ed-drawer__toggle'); if(!b)return;
    e.preventDefault();e.stopPropagation();
    var o=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',o?'true':'false');document.getElementById(b.getAttribute('aria-controls')).hidden=!o;
  },true);
})();
// Country / currency selector (2026-10-23): disclosure + localization form submit.
(function(){
  function opts(r){return Array.prototype.slice.call(r.querySelectorAll('.ed-loc__option'));}
  function setOpen(r,open,focusToggle){
    var t=r.querySelector('.ed-loc__toggle'),l=r.querySelector('.ed-loc__list');if(!t||!l)return;
    t.setAttribute('aria-expanded',open?'true':'false');l.hidden=!open;r.classList.toggle('is-open',open);
    if(open){var o=opts(r),c=r.querySelector('.ed-loc__option[aria-current="true"]')||o[0];if(c)c.focus();}
    else if(focusToggle){t.focus();}
  }
  function closeAll(except){document.querySelectorAll('[data-ed-loc].is-open').forEach(function(r){if(r!==except)setOpen(r,false);});}
  document.querySelectorAll('[data-ed-loc]').forEach(function(r){
    var t=r.querySelector('.ed-loc__toggle'),input=r.querySelector('input[name="country_code"]'),escaped=false;
    t.addEventListener('click',function(e){e.preventDefault();var o=t.getAttribute('aria-expanded')!=='true';closeAll(r);setOpen(r,o);});
    opts(r).forEach(function(b){b.addEventListener('click',function(){if(input)input.value=b.getAttribute('data-country');});});
    r.addEventListener('keydown',function(e){
      if(!r.classList.contains('is-open'))return;
      var o=opts(r),i=o.indexOf(document.activeElement);
      if(e.key==='Escape'){e.preventDefault();e.stopPropagation();escaped=true;setOpen(r,false,true);}
      else if(e.key==='ArrowDown'){e.preventDefault();o[(i+1)%o.length].focus();}
      else if(e.key==='ArrowUp'){e.preventDefault();o[(i-1+o.length)%o.length].focus();}
      else if(e.key==='Home'){e.preventDefault();o[0].focus();}
      else if(e.key==='End'){e.preventDefault();o[o.length-1].focus();}
    });
    // Stop the theme drawer from treating this Escape as "close the whole menu".
    r.addEventListener('keyup',function(e){if(e.key==='Escape'&&escaped){e.stopPropagation();escaped=false;}});
    r.addEventListener('focusout',function(e){if(r.classList.contains('is-open')&&!r.contains(e.relatedTarget))setTimeout(function(){if(!r.contains(document.activeElement))setOpen(r,false);},0);});
  });
  document.addEventListener('click',function(e){if(!e.target.closest||!e.target.closest('[data-ed-loc]'))closeAll();});
})();
